import { render, staticRenderFns } from "./SecuritySettingsCard.vue?vue&type=template&id=e533e8a6&scoped=true"
import script from "./SecuritySettingsCard.vue?vue&type=script&lang=js"
export * from "./SecuritySettingsCard.vue?vue&type=script&lang=js"
import style0 from "./SecuritySettingsCard.vue?vue&type=style&index=0&id=e533e8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e533e8a6",
  null
  
)

export default component.exports